<ion-fab *ngIf="balance.balance > 0" [class.acima-da-barra-do-carrinho]="barraDoCarrinhoVisivel" vertical="bottom" horizontal="start" slot="fixed" class="pointer" (click)="goToCashback()">
  <div class="balance-cashback">
    <img src="assets/icon/cashback-w.svg" alt="Cashback" height="26px">
    <ion-text>
      <!-- Saldo de cashback do consumidor, no cardápio. -->
		<h6>{{ balance.balance | multiCurrency}}</h6>
      <p>Val: {{ balance.expirationDate | date:'dd/MM/yyyy' }}</p>
    </ion-text>
  </div>
</ion-fab>
